import { EpDevPDocumentTypes } from "./constants";
import { IEpDevPAuthRef } from "./types/EpDevPAuthReferenceServiceTypes";

class EpDevPAuthReferenceService {
  // private readonly ComponentName = "EpDevPAuthReferenceService";

  public createAuthorizationRef(authRef: IEpDevPAuthRef): string {
    return `${authRef.documentType}:${authRef.systemId}/${authRef.organizationId}/${authRef.domainId}/${authRef.assetId}`;
  }

  public getAuthRef(authorizationRef: string): IEpDevPAuthRef {
    const name = authorizationRef.split(':');
    const path = name[1].split('/');
    return {
      documentType: name[0] as unknown as EpDevPDocumentTypes,
      systemId: path[0],
      organizationId: path[1],
      domainId: path[2],
      assetId: path[3]
    };
  }

}

export default new EpDevPAuthReferenceService();
